import bannerApiFactory from '../../modules/banner/bannerApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getCategoryBannersActionCreators,
  getSearchBannersActionCreators,
  getTagBannersActionCreators,
} from '../actions/bannerActions';

function bannerSagasFactory({storefrontApiClient}) {
  const bannerApi = bannerApiFactory(storefrontApiClient);

  const getCategoryBannersSaga = generateDefaultAsyncSaga(
    bannerApi.getBanners,
    getCategoryBannersActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getSearchBannersSaga = generateDefaultAsyncSaga(
    bannerApi.getBanners,
    getSearchBannersActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getTagBannersSaga = generateDefaultAsyncSaga(
    bannerApi.getBanners,
    getTagBannersActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetCategoryBanners = generateDefaultAsyncWatcher(
    'GET_CATEGORY_BANNERS',
    getCategoryBannersSaga
  );

  const watchGetSearchBanners = generateDefaultAsyncWatcher(
    'GET_SEARCH_BANNERS',
    getSearchBannersSaga
  );

  const watchGetTagBanners = generateDefaultAsyncWatcher(
    'GET_TAG_BANNERS',
    getTagBannersSaga
  );

  const bannerSagas = [
    watchGetCategoryBanners(),
    watchGetSearchBanners(),
    watchGetTagBanners(),
  ];

  return bannerSagas;
}

export default bannerSagasFactory;
